<div class="row" *ngIf="widgetType">
  <div class="col-lg-3">
    <div class="form-group input-group-sm">
      <label>Name</label>
      <input type="text" placeholder="name" class="form-control" [(ngModel)]="w.name"
      />
    </div>
  </div>
  <div class="col-lg-6">
    <div class="form-group input-group-sm">
      <label>Period</label>
      <app-time-period [(period)]="w.period" [type]="'text'"></app-time-period>
    </div>
  </div>
  <div class="col-lg-3">
    <div class="form-group input-group-sm">
      <label>Refresh (Seconds)</label>
      <input min="60" type="number" placeholder="refresh interval" class="form-control" [(ngModel)]="w.refreshInterval"
      />
    </div>
  </div>
  <div class="col-lg-3">
    <div class="form-group input-group-sm">
      <label>Widget Size</label>
      <select [(ngModel)]="w.size" class="input-group form-select">
        <option value="3">3</option>
        <option value="4">4</option>
        <option value="5">5</option>
        <option value="6">6</option>
        <option value="7">7</option>
        <option value="8">8</option>
        <option value="9">9</option>
        <option value="10">10</option>
        <option value="11">11</option>
        <option value="12">12</option>
      </select>
    </div>
  </div>
  <div class="col-lg-3">
    <div class="form-group input-group-sm">
      <label>Widget Style</label>
      <select [(ngModel)]="w.cssClass" class="input-group form-select">
        <option value="bg-emphasis bg-opacity-15">Black 15% Opactity</option>
        <option value="bg-emphasis bg-opacity-25">Black 25% Opactity</option>
        <option value="bg-emphasis bg-opacity-30">Black 30% Opactity</option>

        <option value="bg-white bg-opacity-15">White 15% Opactity</option>
        <option value="bg-white bg-opacity-25">White 25% Opactity</option>
        <option value="bg-white bg-opacity-30">White 30% Opactity</option>

        <option value="bg-primary bg-opacity-15">Blue 15% Opactity</option>
        <option value="bg-primary bg-opacity-25">Blue 25% Opactity</option>
        <option value="bg-primary bg-opacity-30">Blue 30% Opactity</option>

        <option value="bg-danger bg-opacity-15">Red 15% Opactity</option>
        <option value="bg-danger bg-opacity-25">Red 25% Opactity</option>
        <option value="bg-danger bg-opacity-30">Red 30% Opactity</option>

        <option value="bg-success bg-opacity-15">Green 15% Opactity</option>
        <option value="bg-success bg-opacity-25">Green 25% Opactity</option>
        <option value="bg-success bg-opacity-30">Green 30% Opactity</option>
      </select>
    </div>
  </div>
  <div class="col-lg-3">
    <div class="form-group input-group-sm">
      <input type="checkbox" [(ngModel)]="widget.showTitle" /> Show Title
    </div>
  </div>
  <div class="col-lg-3">
    <div class="form-group input-group-sm">
      <label>Image Source (Link)</label>
      <input type="text" placeholder="image.jpg" class="form-control" [(ngModel)]="w.imageUrl"/>
    </div>
  </div>  
  <div class="col-lg-3">
    <div class="form-group input-group-sm">
      <label>Image Source (Embed) <b *ngIf="fileError">File To Big</b></label>
      <input type="file" class="form-control" (change)="uploadImageFile($event.target.files, imgObj)" placeholder="Upload file" accept=".png,.jpg,.jpeg,.gif,.svg"/>
    </div>
  </div>
</div>
<div class="row mt-3">
  <div class="col-lg-3">
    <button (click)="addItem()" class="btn btn-primary btn-block" type="submit">
      <i class="fa fa-line-chart"></i> Add Time Series
    </button>
  </div>
</div>
<br/>
<div class="row">
  <div class="col-lg-12">
    <tabset>
      <tab *ngFor="let tab of w.timeSeriesDetailList; index as i" [heading]="tab.name == null ? tab.uri : tab.name" [active]="tab.active" (select)="tab.active = true" (deselect)="tab.active = false" [disabled]="tab.disabled" [removable]="tab.removable" (removed)="removeTimeSeries(tab)">
        <div class="row mt-3">
          <div class="col-lg-4" *ngIf="!widget.tagMatch">
            <div class="form-group input-group-sm">
              <label>Name</label>
              <input type="text" class="form-control" [(ngModel)]="tab.name"/>
            </div>
            <div class="form-group input-group-sm form-check-inline">
              <input type="checkbox" [(ngModel)]="tab.showName" /> Show Name
            </div>
            <div class="form-group input-group-sm">
              <label>Display Option</label>
              <select [(ngModel)]="tab.displayOption" class="input-group form-select">
                <option value="text">Text</option>
                <option value="dot">Dot</option>
                <option value="light-stack">Light Stack</option>
              </select>
            </div>
            <div class="form-group input-group-sm" *ngIf="tab && tab.embeddedDashboard">
              <label>Open Dashboard on Click</label>
              <select [(ngModel)]="tab.embeddedDashboard.dashboardId" class="input-group form-select">
                <option value="">Off</option>
                <option *ngFor="let d of dashboards" [value]="d.dashboardId">{{d.name}}</option>
              </select>
            </div>
            <div class="form-group input-group-sm">
              <label>Select Time Series
                <button [style.background]="tab.colour" [cpPosition]="'bottom'" [(colorPicker)]="tab.colour" class="colour-picker-button"></button>
              </label>
              <app-uri-select [customerId]="dashboard.customerId" [timeSeriesDetail]="tab" [enableMediaSearch]="false" [enableTagMatch]="true" [siteTypeCode]="dashboard.siteType" [siteUri]="siteUri"></app-uri-select>
              <!--<app-time-series-select [timeSeriesDetail]="tab" [enableTagMatch]="true"></app-time-series-select>-->
            </div>
            <div class="form-group input-group-sm">
              <app-transform-editor [transforms]="tab.transforms"></app-transform-editor>
            </div>
          </div>
          <div class="col-lg-8">
            <tabset>
              <tab heading="Location Select">
                <div class="row mt-3">
                  <div class="col-lg-12">
                    <app-image-overlay [imageUrl]="imageUrl" [imageData]="imageData" [overlayConfig]="[tab]" [itemPos]="i" [allowPointSelection]="true" ></app-image-overlay>
                  </div>
                  <div class="col-lg-12">
                    <div class="form-inline overlay-input-container">
                      <div class="col-lg-6">
                      <div class="form-group">
                        <div class="input-group">
                          <label class="sr-only">X</label>
                          <input type="text" placeholder="0.000" class="form-control"[(ngModel)]="tab.x" (change)="updateImage()"/>    
                          <button (click)="increaseX(tab)"  type="button" class="btn btn-white"><i class="fa fa-plus"></i> </button>
                          <button (click)="decreaseX(tab)" type="button" class="btn btn-white"><i class="fa fa-minus"></i> </button>
                        </div>
                      </div>
                      </div>
                      <div class="col-lg-6">
                      <div class="form-group">
                        <div class="input-group">
                          <label class="sr-only">Y</label>
                          <input type="text" placeholder="0.000" class="form-control" [(ngModel)]="tab.y" (change)="updateImage()"/>
                          <button (click)="increaseY(tab)" type="button" class="btn btn-white"><i class="fa fa-plus"></i> </button>
                          <button (click)="decreaseY(tab)" type="button" class="btn btn-white"><i class="fa fa-minus"></i> </button>
                        </div>
                      </div>    
                      </div>
              
                    </div>
                  </div>
                </div>  
              </tab>
              <tab heading="Colour Rules">
                <div class="row mt-3">
                  <div class="col-lg-6">
                    <div class="panel">
                      <div class="panel-body">
                        <div class="row">
                          <div class="col-sm-12">
                            <div class="form-group">
                              <label class="control-label">Min / Max</label>
                              <div class="input-group bg-opacity-30 bg-default">
                                <input type="text" placeholder="min" class="form-control" [(ngModel)]="tab.default.min">
                                <input type="text" placeholder="max" class="form-control" [(ngModel)]="tab.default.max">
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-6">
                    <div class="panel">
                      <div class="panel-body">
                        <div class="row">
                          <div class="col-sm-12">
                            <div class="form-group">
                              <label class="control-label">Min / Max</label>
                              <div class="input-group  bg-opacity-30 bg-primary">
                                <input type="text" placeholder="min" class="form-control" [(ngModel)]="tab.primary.min">
                                <input type="text" placeholder="max" class="form-control" [(ngModel)]="tab.primary.max">
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-6">
                    <div class="panel panel-success">
                      <div class="panel-body">
                        <div class="row">
                          <div class="col-sm-12">
                            <div class="form-group">
                              <label class="control-label">Min / Max</label>
                              <div class="input-group bg-opacity-30 bg-success">
                                <input type="text" placeholder="min" class="form-control" [(ngModel)]="tab.success.min">
                                <input type="text" placeholder="max" class="form-control" [(ngModel)]="tab.success.max">
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>    
                  <div class="col-lg-6">
                    <div class="panel panel-info">
                      <div class="panel-body">
                        <div class="row">
                          <div class="col-sm-12">
                            <div class="form-group">
                              <label class="control-label">Min / Max</label>
                              <div class="input-group bg-opacity-30 bg-info">
                                <input type="text" placeholder="min" class="form-control" [(ngModel)]="tab.info.min">
                                <input type="text" placeholder="max" class="form-control" [(ngModel)]="tab.info.max">
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>    
                  <div class="col-lg-6">
                    <div class="panel panel-warning">
                      <div class="panel-body">
                        <div class="row">
                          <div class="col-sm-12">
                            <div class="form-group">
                              <label class="control-label">Min / Max</label>
                              <div class="input-group bg-opacity-30 bg-warning">
                                <input type="text" placeholder="min" class="form-control" [(ngModel)]="tab.warning.min">
                                <input type="text" placeholder="max" class="form-control" [(ngModel)]="tab.warning.max">
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-6">
                    <div class="panel panel-danger">
                      <div class="panel-body">
                        <div class="row">
                          <div class="col-sm-12">
                            <div class="form-group">
                              <label class="control-label">Min / Max</label>
                              <div class="input-group bg-opacity-30 bg-danger">
                                <input type="text" placeholder="min" class="form-control" [(ngModel)]="tab.danger.min">
                                <input type="text" placeholder="max" class="form-control" [(ngModel)]="tab.danger.max">
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </tab>
            </tabset>
          </div>         
        </div>
      </tab>
    </tabset>
  </div>
</div>
